import { api } from '../../../services/api/client';
import type { CopytradeContent } from '../../../types';

export interface CopytradePayload {
  title: string;
  short_description?: string;
  long_description?: string;
  steps?: string[];
  risk_disclaimer?: string;
  embed_video_url?: string;
  cta_label?: string;
  cta_link?: string;
  is_published?: boolean;
}

export async function fetchPublishedCopytrade(): Promise<CopytradeContent | null> {
  const { data } = await api.get<CopytradeContent | null>('/public/copytrade');
  return data;
}
export async function adminListCopytrade(): Promise<CopytradeContent[]> {
  const { data } = await api.get<CopytradeContent[]>('/admin/copytrade');
  return data;
}
export async function adminCreateCopytrade(payload: CopytradePayload): Promise<CopytradeContent> {
  const { data } = await api.post<CopytradeContent>('/admin/copytrade', payload);
  return data;
}
export async function adminUpdateCopytrade(id: string, payload: Partial<CopytradePayload>): Promise<CopytradeContent> {
  const { data } = await api.put<CopytradeContent>(`/admin/copytrade/${id}`, payload);
  return data;
}
export async function adminDeleteCopytrade(id: string): Promise<any> {
  const { data } = await api.delete(`/admin/copytrade/${id}`);
  return data;
}
